
export function othersText(language: string) {
    const lang = language.split("-")[0];
    const otros: any = {
        "en": "Other",
        "it": "Altri",
        "es": "Otros",
        "fr": "Autres",
        "de": "Andere",
        "nb": "Andre",
    }
    return otros[lang] || "Others";
}

export function viewMoreText(language: string) {
    const lang = language.split("-")[0];
    const view_more : any = {
        "en": "View more",
        "it": "Vedi di più",
        "fr": "Voir plus",
        "de": "Mehr anzeigen",
        "es": "Ver más",
        "nb": "Se mer"
    }
    return view_more[lang] || "View more";
}


